import { creditFeatureByPath } from "../redux/permissions/creditFeatureByPath";
import { emitCreditsHeaders, emitInsufficientCredits, emitLastCreditSpent, parseCreditsHeaders, spentLastCredit, } from "../redux/permissions/creditsHeaderBridge";
/*
  Metered routes report the post-call balance on every response
  (X-Credits-Left / X-Credit-Charged), keeping the slice in sync without a
  follow-up GET /credits. Non-metered responses parse to null. Wrapped, because
  credit bookkeeping must never break a request.
*/
const syncCreditsFromHeaders = (headers) => {
    try {
        const payload = parseCreditsHeaders(headers);
        if (payload)
            emitCreditsHeaders(payload);
        return payload;
    }
    catch {
        // ignore — the balance resyncs on the next /credits fetch
        return null;
    }
};
export const creditsOnResponse = (response) => {
    const payload = syncCreditsFromHeaders(response.headers);
    // The call succeeded and took the last credit: the out-of-credits moment,
    // raised now rather than on the next click that would be refused.
    if (payload && spentLastCredit(payload)) {
        emitLastCreditSpent({
            featureId: creditFeatureByPath(response.config?.url),
        });
    }
    return response;
};
/**
 * The 402 backstop, for the balance `useCreditGate` can't see: another device
 * spending, a price change mid-session. Always re-rejects.
 */
export const creditsOnResponseError = (error) => {
    // 402: refused, nothing charged. `balanceApplied` says whether the headers
    // already corrected the balance. The gate is raised either way.
    if (error?.response) {
        const balanceApplied = !!syncCreditsFromHeaders(error.response.headers);
        if (error.response.status === 402) {
            emitInsufficientCredits({
                balanceApplied,
                // The URL is the only clue to what was blocked; a miss reads as
                // generic copy.
                featureId: creditFeatureByPath(error.config?.url),
            });
        }
    }
    return Promise.reject(error);
};
//# sourceMappingURL=creditsInterceptor.js.map